import { render, staticRenderFns } from "./forbidden-page.vue?vue&type=template&id=2d343c4b&scoped=true"
import script from "./forbidden-page.vue?vue&type=script&lang=js"
export * from "./forbidden-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d343c4b",
  null
  
)

export default component.exports